import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { columns } from "@/sites/data/services/table-config";
import type { ContactPanelBaseProps } from "../types";
import { ContactServicesMenu } from "./contact-services-menu";

export function ContactServices({ contactId }: ContactPanelBaseProps) {
	/** Hooks */

	/** Query */
	const { data, queryKey, refetch, isLoading } = useQuery({
		queryKey: ["contact", contactId, "services"],
		queryFn: async () => {
			if (!contactId) return [];
			const response = await client.contacts[":contactId"].services.$get({
				param: { contactId },
			});
			const data = await responseHandler(response);
			return data.services;
		},
	});

	/** Render */
	return (
		<DataTable
			data={data as any}
			columns={columns as any}
			queryKey={queryKey}
			refetch={refetch}
			isLoading={isLoading}
			persistenceKey="services-table"
			initialPinningState={{
				start: ["fullNumber"],
			}}
			menu={
				<ContactServicesMenu
					queryKey={queryKey}
					contactId={contactId}
				/>
			}
		/>
	);
}
